<template>
  <v-container>
    <v-alert v-if="formError" prominent type="error">
      <v-row align="center">
        <v-col class="grow">
          <small>Verifique se os dados estão corretos.</small>
        </v-col>
      </v-row>
    </v-alert>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="4">
        <h1 class="text-center font-weight-light">Redefinir Senha</h1>
        <v-form ref="form" class="mt-12" v-model="valid" lazy-validation>
          <v-alert v-if="error" class="mb-12" dense outlined type="error">
            <small>Verifique se os dados estão corretos.</small>
          </v-alert>
          <v-text-field
            :type="show1 ? 'text' : 'password'"
            class="mt-2"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            v-model.trim="password"
            :rules="passwordRules"
            placeholder="Nova senha"
            label="Nova senha"
            @click:append="show1 = !show1"
            outlined
            required
          ></v-text-field>
          <v-text-field
            :type="show2 ? 'text' : 'password'"
            class="mt-2"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            v-model.trim="confirmPassword"
            :rules="[passwordConfirmationRule]"
            placeholder="Confirmar nova senha"
            label="Confirmar nova senha"
            @click:append="show2 = !show2"
            outlined
            required
          ></v-text-field>

          <v-btn
            :disabled="!valid"
            color="primary"
            class="mt-4 mx-auto d-block"
            @click="validate"
          >Confirmar</v-btn>
        </v-form>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="300">
          <v-card>
            <v-card-title class="headline">Redefinição de senha</v-card-title>
            <v-card-text>Senha alterada com sucesso!</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" dark @click="backToLogin">Entrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { auth } from "../../firebase.js";
import { router } from "../router";

export default {
  data: () => ({
    text: "PasswordReset",
    dialog: false,
    formError: false,
    valid: true,
    show1: false,
    show2: false,
    error: false,
    password: "",
    confirmPassword: "",
    passwordRules: [(v) => !!v || "Campo obrigatório"],
    confirmPasswordRules: [(v) => !!v || "Campo obrigatório"],
  }),
  mounted: function () {
  },
  computed: {
    passwordConfirmationRule: function () {
      return (
        this.password === this.confirmPassword ||
        "As senhas precisam ser iguais"
      );
    },
    emptyField: function () {
      return !!this.confirmPassword || "Campo obrigatório";
    },
  },
  methods: {
    validate() {
      this.dialog = true;
    },
    passwordReset() {},
    handleResetPassword(actionCode) {
      let newPass = this.password;

      auth
        .verifyPasswordResetCode(actionCode)
        .then(function () {
          //let accountEmail = email;
          auth
            .confirmPasswordReset(actionCode, newPass)
            .then(function (resp) {
              this.dialog = true;
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          // Invalid or expired action code. Ask user to try to reset the password
          // again.

          console.log(error);
        });
    },
    backToLogin(){
      router.push({name:"Login"});
    }
  },
};
</script>